import { Row, Col, Button, Image } from 'react-bootstrap';

import openJobs from './openPositions.js';


function OpenJobsDisclaimer() {
   const openPositionsAvailable = areOpenPositionsAvailable();
   if(openPositionsAvailable) {
    return (
        <Row className='highlight-wrapper py-3'>
            <Col className='text-center highlight job-disclaimer'>
                <h2 className='man-white'>Wir suchen Dich!</h2>
                <Image src="/ausbildung.png" className='rounded-circle' height="150px" width="150px"/>
                <br/>
                <Button className='btn btn-outline-secondary btn-lg px-4' href='/career'>Zu unseren Stellenanzeigen</Button>
            </Col>
        </Row>
   );
   }

   return null;
}

function areOpenPositionsAvailable() {
    return openJobs.length > 0;
}

export default OpenJobsDisclaimer;